import { CustomFormUtilsService } from './../../custom-form-utils.service';
import { filter } from 'rxjs/operators';
import { CustomEntityService } from './../../apiclient/api/customEntity.service';
import { UserSessionService } from './../../UserSession/user-session.service';

import { ViewCell, Cell, DefaultEditor, Editor } from 'ng2-smart-table';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { TYPE_FIELD_LIST, EDITABLE_FIELDS } from './customformsConstants';
import { ExtraPropertyFieldEditorComponent } from './extrapropertyfield.component';
import { CustomCriteriaService } from './customCriteriaService';


/**
 * Componente que renderiza la celda TIPO en la tabla de customform
 */
@Component({
  template: `
  <div>

            <angular2-multiselect [data]=tiposCampo [(ngModel)]="currentValue"
            (onSelect)="changeSelect(true)"
            [settings]="dropdownSettings"></angular2-multiselect>
  </div>
   <div *ngIf="cell.newValue == 'customentity_list'" >


            <angular2-multiselect [data]=entities [(ngModel)]="selectedEntity"
            (onSelect)="changeEntity()"
            [settings]="dropdownSettingsEntities"></angular2-multiselect>


   </div>

   <div *ngIf="cell.newValue == 'customentity_list'">
            <nb-select placeholder="Atributo" fullWidth name="atributo" [(ngModel)]="entityConfig.key">
              <nb-option [value]="item.id" *ngFor="let item of entityAttributes">{{item.name}}</nb-option>
            </nb-select>

   </div>

   <div class="multiselection" *ngIf="cell.newValue == 'customentity_list'">
          <nb-checkbox  [(ngModel)]="entityConfig.multiple">Multiseleccion</nb-checkbox>


   </div>

   <div *ngIf="cell.newValue == 'subform'" >


            <angular2-multiselect [data]=subforms [(ngModel)]="selectedSubform"
            (onSelect)="changeSubform()"
            [settings]="dropdownSettingsSubforms"></angular2-multiselect>


   </div>

   <div class="multiselection" *ngIf="cell.newValue == 'subform'">
      <nb-checkbox (change)="onCheckChanged()" [(ngModel)]="cLimitar">Limitar</nb-checkbox>
    </div>

    <div *ngIf="cell.newValue == 'subform'" >
          <input type="text" nbInput fullWidth [(ngModel)]="subformConfig.ocurrencies" [disabled]="!cLimitar" pattern="^[0-9]+$" />
   </div>

   <div *ngIf="cell.newValue == 'sequence' || cell.newValue.fieldType == 'sequence'" >
   <label>Inicio secuencia:&nbsp;</label>
   <input type="number" nbInput fullWidth [(ngModel)]="sequenceField.initVal"/>
  </div>

  <div *ngIf="cell.newValue == 'sequence' || cell.newValue.fieldType == 'sequence'" >
    <label>Incremento:&nbsp;</label>
    <input type="number" nbInput fullWidth [(ngModel)]="sequenceField.stepVal"/>
  </div>
  `,
  styles: ['.multiselection { margin-top:16px; }']
})
export class TypePropertyFieldComponent extends DefaultEditor implements OnInit {

  availableFields: any = {
//    'min': ['date','date_range','datetime','datetime_range','hour'],
//    'max': ['date','date_range','datetime','datetime_range','hour'],
    'criteria': ['number','date','date_range','datetime','datetime_range','hour','hours'],
    'auto': ['location'],
    'elements': ['select','radio','multi_select'],
    'id':['text','number','textarea','radio','random_id','checkbox','select','date',
    'date_range','datetime','datetime_range','hour','hours',
    'picture','picture_compress','product_list','machinery_list','user_list','customentity_list','subform','sequence'],
  }

  public cLimitar = false;
  public subformConfig = {
    id: 0, ocurrencies: ''
  };

  sequenceField = {fieldType: 'sequence', initVal: 1, stepVal: 1};
  initVal=1;
  stepVal=1;
  fieldData : any;

  currentValue: any;
  entities: any;
  subforms: any;
  entityAttributes:any[];
  selectedEntity = [];
  selectedSubform = [];
  selectedAttribute = [];

  tiposCampo = TYPE_FIELD_LIST;
  entityConfig: any;
  multiselection: boolean;
  dropdownSettings = {
    singleSelection: true,
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    labelKey:"title",
    primaryKey:"value",
    searchPlaceholderText:"Buscar",
    text:"Seleccione tipo"
  };

  dropdownSettingsEntities = {
    singleSelection: true,
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    labelKey:"name",
    primaryKey:"id",
    searchPlaceholderText:"Buscar",
    text:"Entidad"
  };

  dropdownSettingsAttributes = {
    singleSelection: true,
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    labelKey:"value",
    primaryKey:"id",
    searchPlaceholderText:"Buscar",
    text:"Atributo"
  };

  dropdownSettingsSubforms = {
    singleSelection: true,
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    labelKey:"form_name",
    primaryKey:"id",
    searchPlaceholderText:"Buscar",
    text:"Subformulario"
  };

  constructor(private customFormUtilsService: CustomFormUtilsService,
    private userSessionService: UserSessionService,
    private modalService: CustomCriteriaService
    ) {
    super();

    }

    /**
     * @ignore
     */
   async ngOnInit() {
    this.tiposCampo.sort((a,b)=>a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1)
    //Obtenemos las entidades



    console.log("TIPO")
    console.log(this.cell)
    if(this.cell.getRow().getData().type != undefined && this.cell.getRow().getData().type != ''){
      this.currentValue = [this.tiposCampo.find(t => t.value == this.cell.getRow().getData().type)];

    }

    console.log(this.currentValue);
    this.fieldData = this.cell.getRow().getData();
    this.changeSelect(false);

    this.onStopEditing.subscribe(evento => {
      console.log("Termino la edición");
    });
  }

  /**
   * Cambia la selección
   */
  public async changeSelect(userOrigin: boolean) {
    console.log("Cambia "+event)
    if(this.currentValue != null && this.currentValue.length > 0 && this.currentValue[0] != undefined){
      this.cell.newValue = this.currentValue[0].value;
    }

    console.log(this.cell.newValue);

    if (this.cell.newValue === 'customentity_list'){



      this.entities = await this.customFormUtilsService.getCompanyEntities();
      this.entities.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);

      if (this.cell.getRow().getData().customEntityConfig == undefined){
        this.cell.getRow().getData().customEntityConfig = {'entity':0,'key':'name','multiple':false};

      }else{

        this.selectedEntity = [this.entities.find(e => e.id == this.cell.getRow().getData().customEntityConfig.entity)]
      }
      this.entityConfig = this.cell.getRow().getData().customEntityConfig
      if (this.cell.getRow().getData().multiselect == undefined){
        this.cell.getRow().getData().multiselect = false
      }
      this.entityConfig.multiple = this.cell.getRow().getData().multiselect
      this.changeEntity()
     // this.selectedAttribute = [this.entityAttributes.find(a => a.id == this.cell.getRow().getData().customEntityConfig.key)]
      console.log(this.entities)
    }

    if (this.cell.newValue === 'sequence'){
      if (this.cell.getRow().getData().initValue === undefined){
        this.cell.getRow().getData().initValue = 1;
      }

      if (this.cell.getRow().getData().stepValue === undefined){
        this.cell.getRow().getData().stepValue = 1;
      }
      this.sequenceField.initVal = this.cell.getRow().getData().initValue;
      this.sequenceField.stepVal = this.cell.getRow().getData().stepValue;

      this.cell.newValue = this.sequenceField;
    }

    if (this.cell.newValue === 'subform'){
      this.subforms = await this.customFormUtilsService.getCompanySubforms();
      this.subforms = this.subforms.filter( cf => cf.module_name == 'subform')
      this.subforms.sort((a,b)=>a.form_name.toLowerCase() < b.form_name.toLowerCase() ? -1 : 1);
      if (this.cell.getRow().getData().subformConfig == undefined){
        this.cell.getRow().getData().subformConfig = {'id':'','ocurrencies':''};
      }else{
        this.selectedSubform = [this.subforms.find(option => option.id === this.cell.getRow().getData().subformConfig.id)];
        if (this.cell.getRow().getData().subformConfig.ocurrencies === 0 || this.cell.getRow().getData().subformConfig.ocurrencies === ''){
          this.subformConfig.ocurrencies = ''
          this.cLimitar = false
        }else{
          this.cLimitar = true
        }
      }
      this.subformConfig = this.cell.getRow().getData().subformConfig
      this.changeSubform()
      console.log(this.subforms)
    }
    this.cell.getRow().cells.forEach((cell) => {
      if (EDITABLE_FIELDS.indexOf(cell.getId()) !== -1){
        console.log("EDITABLE")
        console.log(cell);
        if (this.currentValue != null && this.currentValue.length > 0 && this.currentValue[0] != undefined){
          if(this.availableFields[cell.getId()].indexOf(this.currentValue[0].value) !== -1){
            cell.getColumn().isEditable = true;
            cell.getColumn().isAddable = true;
          }else{
            cell.getColumn().isEditable = false;
            cell.getColumn().isAddable = false;
          }
        }else{
          cell.getColumn().isEditable = false;
          cell.getColumn().isAddable = false;

        }
      }
    })

    if (this.currentValue != null && this.currentValue.length > 0 && this.currentValue[0] != undefined){
      if(this.availableFields['criteria'].indexOf(this.currentValue[0].value) !== -1){
        this.cell.getRow().cells.find(c => c.getId() == 'criteria').getColumn().isEditable = true
        this.cell.getRow().cells.find(c => c.getId() == 'criteria').getColumn().isAddable = true



        //this.modalService.vTip = this.currentValue[0].value;

        //Si había un criteria al cambiar el tipo se tiene que borra
        if (userOrigin){


          this.updateValueTipo(this.currentValue[0].value);
        }
/*
        /*
        if (!this.cell.getRow().getData().vTraducido.toString().startsWith("Valor ")){
          //El valor devuelto es incorrecto para el tipo elegido
          this.updateValueVacio();
        }
        */
      }else{
        this.cell.getRow().cells.find(c => c.getId() == 'criteria').getColumn().isEditable = false
        this.cell.getRow().cells.find(c => c.getId() == 'criteria').getColumn().isAddable = false
      }
    }else{
      this.cell.getRow().cells.find(c => c.getId() == 'criteria').getColumn().isEditable = false
      this.cell.getRow().cells.find(c => c.getId() == 'criteria').getColumn().isAddable = false

    }

  }


  // Wrong not working example:
  // this function will not reset back to the initial value after cancel
  /**
   * @ignore
   */
  wrongValueChange() {
    console.log("Otro");
  }

  // Correct working example:
  // this will reset back to the initial value after cancel
  /**
   * @ignore
   */
  rightValueChange() {
      console.log("Seteamos valor")
  }

  /**
   * Obtiene los atributos de la entidad
   * @param entity entidad
   * @returns Atributos
   */
  getAttributesByEntity(entity){

    //var attributesList=[{'id':'name','value':'Nombre'}]
    var elements = this.entities.filter(en => en.id == entity)[0].attributes
    return elements;
    /*elements.forEach(element => {
      attributesList.push({id:element,value:element})
    });
    return attributesList;
    */
  }

  /**
   * Cambia la entidad
   */
  changeEntity(){
    if (this.selectedEntity[0] != undefined){
      this.entityConfig.entity = this.selectedEntity[0].id
      this.entityAttributes = this.getAttributesByEntity(this.selectedEntity[0].id)
    }

  }

    /**
   * Cambia el subformulario
   */
    changeSubform(){
      if (this.selectedSubform != undefined){
        if (this.selectedSubform[0] != undefined){
          this.subformConfig.id = this.selectedSubform[0].id
          this.cell.getRow().getData().subformConfig = this.subformConfig
        }
      }
    }
    onCheckChanged() {
      this.subformConfig.ocurrencies = '';
    }

  changeAttribute(){
    this.entityConfig.key = this.selectedAttribute[0].id
  }

  updateValueTipo(tipo: string): void {
    this.modalService.updateFieldType(tipo);
  }



}
